import { escapeHtml } from "@utils/html/html.utils";
import Component from "../../component.abstract";

interface SimpleSelectProps {
    items?: Array<SimpleSelectItem>
}

export interface SimpleSelectItem {
    uri: string;
    label: string;
    isValid?(): boolean;
}

export default class SimpleSelect extends Component {
    private items: Array<SimpleSelectItem> = [];
    private lis: Array<HTMLLIElement>;
    private button: HTMLDivElement;
    private dropdown: HTMLUListElement;

    constructor(
        props: SimpleSelectProps,
        element:HTMLElement
    ) {
        super(props, element);
    }

    mounted(): void {
        // Create selector button
        this.button = document.createElement("div");
        this.button.classList.add("select-button");

        this.element.appendChild(this.button);

        // Create selector dropdown
        this.dropdown = document.createElement("ul");
        this.dropdown.classList.add("select-dropdown");
        this.addItems();
        this.element.appendChild(this.dropdown);

        // Open/close on click
        this.button.addEventListener("click", () => {
            this.dropdown.classList.toggle("opened");
        });

        // Close on click outside component
        window.addEventListener("click", (event: MouseEvent) => {
            if ((<HTMLElement> event.target).closest("[data-simple-select]") !== this.element) {
                this.dropdown.classList.remove("opened");
            }
        });
    }

    addItems(): void {
        // Remove previous items
        this.dropdown.textContent = "";
        this.lis = [];

        // Create items
        this.items.forEach(item => {
            const li = document.createElement("li");   
            li.setAttribute("data-item", item.uri);
            // An inner span is needed for the ellipsis
            li.innerHTML = `<span>${escapeHtml(item.label)}</span>`;

            this.dropdown.appendChild(li);

            this.lis.push(li);
        });

        this.lis.forEach(li => {
            li.addEventListener("click", () => {
                this._select(li);
            });
        });
    }

    updateItems(items: Array<SimpleSelectItem>): void {
        this.items = items;
        this.addItems();
    }

    selectItem(value: string): void {
        for (let i = 0; i < this.lis.length; i++) {
            if (this.lis[i].getAttribute("data-item") === value) {
                this._select(this.lis[i]);
                break;
            }
        }
    }

    unselect(): void {
        this.button.setAttribute("data-item", "");
        this.button.innerHTML = "";
    }

    _select(li: HTMLLIElement): void {
        const value = li.getAttribute("data-item");

        // Update button
        this.button.setAttribute("data-item", value);
        // An inner span is needed for the ellipsis
        this.button.innerHTML = `<span>${escapeHtml(li.innerText)}</span>`;

        this.dropdown.classList.remove("opened");

        // Finally, send the selected event
        PubSub.publish("simple-select.selected", {
            instance: this,
            value: value
        });
    }

    getValue(): string {
        return this.button.getAttribute("data-item");
    }

    getCriterionFormatValue(): SimpleSelectItem {
        return {
            "label": this.button.innerText, 
            "uri": this.button.getAttribute("data-item"),
            isValid() {
                return !!this.uri;
            }
        };
    }
}